import { Button as MUIButton } from "@material-ui/core";
import styled from "styled-components";
import { selector } from "../../../utils/selector";
import { patientFacingTheme } from "../../../themes/patient-facing";

const { colors } = patientFacingTheme;

export const StyledButtonPatientFacing = styled(MUIButton)`
  &${selector`.MuiButton-contained`} {
    background: ${colors.camelot};
    color: ${colors.white};
    border-color: ${colors.camelot};
    border-radius: 8px;
    font-size: 14px;
    text-transform: none;
    padding: 8px 12px;
    font-weight: 700;

    &:hover {
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.08);
    }
  }

  &${selector`.MuiButton-outlined`},
    &${selector`.MuiButton-outlinedSecondary`} {
    background: ${colors.white};
    color: ${colors.ciqBrand};
    border-color: ${colors.ciqBrand};
    border-radius: 8px;
    font-size: 14px;
    text-transform: none;
    padding: 8px 12px;
    font-weight: 700;

    &:hover {
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.08);
    }
  }
`;
